module.exports = __webpack_public_path__ + "img/iconBg1.627e9e58.png";